module.exports = __webpack_public_path__ + "img/video_2.956413f2.jpg";